'use client'

import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts'
import type { LinePayload } from '../svs-types'
import { resolveColor } from '../color-mapping'

interface LineRendererProps {
  payload: LinePayload
}

export function LineRenderer({ payload }: LineRendererProps) {
  const { categories, series } = payload.data
  const options = payload.options || {}
  const showLegend = series.length > 1

  const data = categories.map((cat, i) => {
    const point: Record<string, unknown> = { name: cat }
    series.forEach((s, si) => {
      point[s.name || `series-${si}`] = s.values[i]
    })
    return point
  })

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 10, right: 20, left: 10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis dataKey="name" label={options.xLabel ? { value: options.xLabel, position: 'insideBottom', offset: -5 } : undefined} />
        <YAxis label={options.yLabel ? { value: options.yLabel, angle: -90, position: 'insideLeft' } : undefined} />
        <Tooltip />
        {showLegend && <Legend />}
        {series.map((s, si) => {
          const key = s.name || `series-${si}`
          const color = resolveColor(s.color, si)
          return (
            <Line
              key={key}
              type={options.smooth ? 'monotone' : 'linear'}
              dataKey={key}
              stroke={color}
              strokeWidth={2}
              dot={options.showPoints !== false}
              connectNulls={false}
              activeDot={{ r: 5 }}
            />
          )
        })}
      </LineChart>
    </ResponsiveContainer>
  )
}
